import { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
    Box,
    Typography,
} from "@mui/material";
import { OnHoldReportHelper } from "../../helper/Reports/GetWageReportHelper";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";
import { useSelector } from "react-redux";

const InEligibleGrid = () => {
    const [empdata, setEmpData] = useState([]);
    const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
    const [filters, setFilters] = useState({
            ats_work_location_id: []
      });
    useEffect(() => {
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
        OnHoldReportHelper({
            ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
        }).then((res) => {
            setEmpData(res?.data?.data);
        });

    }, [filters]);
    const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
    const handleWorkLoacation = () => {
        if(workLocationAccess_options) {
            setWorklocationData({ load: false, values: workLocationAccess_options || [] })
        } else {
            setWorklocationData({ load: false, values: [] })
        }
    }
    useEffect(() => {
        handleWorkLoacation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[workLocationAccess_options])
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }

    return (
        <>
            <Box sx={{ maxHeight: "calc(100vh - 115px)", overflowY: "auto" }}>
                <MaterialTable
                    columns={[
                        {
                            title: "Name",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            field: "employee_name",
                            grouping: false,
                        },
                        {
                            title: "Email",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            field: "email",
                            grouping: false,
                        },
                        {
                            title: "Work Location",
                            field: "work_location_name",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            grouping: false,
                            render: (rowData) => rowData?.work_location_name || "N/A"
                        },
                        {
                            title: "Joining Date",
                            field: "doj",
                            cellStyle: { padding: "0px 10px 0px 13px" },
                            render: (rowData) => {
                                return ConvertDate(rowData.doj);
                            },
                            grouping: false,
                        },
                        {
                            title: "Last Modified On",
                            field: "last_toggle_on",
                            cellStyle: { padding: "0px 10px 0px 13px" },
                            render: (rowData) => {
                                return ConvertDate(rowData.last_toggle_on);
                            },
                            grouping: false,
                        },
                    ]}
                    data={empdata}
                    options={{
                        maxBodyHeight: "calc(100vh - 250px)",
                        minBodyHeight: "calc(100vh - 250px)",
                        rowStyle: { fontSize: "13px" },
                        headerStyle: { padding: "5px 10px 5px 13px", fontWeight: "bold" },
                        sorting: true,
                        search: true,
                        searchText: "",
                        searchFieldAlignment: "right",
                        searchAutoFocus: true,
                        searchFieldVariant: "standard",
                        filtering: false,
                        paging: true,
                        pageSizeOptions: [25, 50],
                        pageSize: 25,
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        paginationPosition: "bottom",
                        exportButton: false,
                        exportAllData: false,
                        exportFileName: "Employees",
                        addRowPosition: "first",
                        selection: false,
                        actionsColumnIndex: -1,
                        showSelectAllCheckbox: true,
                        showTextRowsSelected: true,
                        grouping: false,
                        columnsButton: false,
                    }}
                    components={{
                        Toolbar: (props) => (
                            <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                                <Box
                                    sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: "#f3edfd",
                                    padding: "0px 0px 0px 20px",
                                    flexGrow: 1,
                                    minHeight: "48px !important",
                                    }}
                                >
                                <Box>
                                    <Typography variant='h6'>
                                        Payroll Onhold employees
                                    </Typography>
                                </Box>
                                <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                                    <SelectableMultiSelect
                                        multiple
                                        label="Work Location"
                                        placeholder="Select Location"
                                        value={filters?.ats_work_location_id}
                                        loading={handleWorkLoacation}
                                        fieldLabel="work_location_name"
                                        name="ats_work_location_id"
                                        size="small"
                                        onChangeEvent={handleFilterChange}
                                        data={worklocationData}
                                        menuHeight={150} // optional
                                    />
                                </Box> 
                                </Box>
                                <Box
                                    sx={{
                                        "& .MuiToolbar-root": {
                                        padding: "12px 16px !important",
                                        margin: "auto !important",
                                        minHeight: "48px !important",
                                        },
                                        "& .MuiFormControl-root": {
                                        margin: "0 !important",
                                        },
                                        "& .MuiInputBase-root": {
                                        marginLeft: "-20px !important",
                                        }
                                    }}
                                    >
                                        <MTableToolbar {...props} />
                                    </Box>
                                </Box>
                        ),
                    }}
                    title=""
                />
            </Box>
        </>
    );
};

export default InEligibleGrid;